import type { ScorecardGroupBy } from 'model/types/scorecard';

export const WIZARD_STEPS = 6;
export const APP_DEFAULT_PATH = '/home';

/** Day-range toggle options for the shared KPIs toolbar (collaboration + base sections). */
export const KPIS_DAY_OPTIONS = [7, 28, 90];

/** Group-by toggle options for the shared KPIs toolbar (YEAR is intentionally not offered). */
export const SCORECARD_GROUP_BY_OPTIONS: ReadonlyArray<{ value: ScorecardGroupBy; labelId: string }> = [
  { value: 'DAY', labelId: 'group-by-day' },
  { value: 'WEEK', labelId: 'group-by-week' },
  { value: 'MONTH', labelId: 'group-by-month' },
  { value: 'QUARTER', labelId: 'group-by-quarter' }
];

export const DEFAULT_SCORECARD_GROUP_BY: ScorecardGroupBy = 'DAY';
